import { render, staticRenderFns } from "./user.vue?vue&type=template&id=2d5695a5&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=2d5695a5&prod&scoped=true&lang=scss"
import style1 from "./user.vue?vue&type=style&index=1&id=2d5695a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5695a5",
  null
  
)

export default component.exports